<template>
  <div class="filter-post" id="filter-post" v-if="isEnable() && isReadyComponent()">
    <div class="filter-post__row">
      <div class="block">
        <div class="filter-post__search">
          <label class="form-label">Поисковый запрос</label>
          <div class="input-group">
            <span class="input-group-text">
              <input class="form-check-input m-0" @change="events.onSearch" type="checkbox" v-model="bootData.search_full_match" title="Точное совпадение">
            </span>
            <div class="input-icon">
              <input @keyup.enter="events.onSearch" type="text" v-model="bootData.search" class="form-control" placeholder="Напишите что-нибудь">
              <button class="btn input-icon-addon__button" @click="events.onSearch">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <circle cx="10" cy="10" r="7" />
                  <line x1="21" y1="21" x2="15" y2="15" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="block">
        <div class="filter-post__date">
          <label class="form-label">Дата публикации</label>
          <Datepicker auto-apply v-model="bootData.date" @update:modelValue="events.applyDate" range multi-calendars locale="ru" format="dd.MM.yyyy" placeholder="Выбрать дату" :enable-time-picker="false" />
        </div>
      </div>

      <div class="block">
        <div class="filter-post__select users">
          <label class="form-label">Пользователь</label>
          <Multiselect @change="events.onUser" v-model="bootData.users" mode="tags" placeholder="Не выбрано" noResultsText="Результатов не найдено" :close-on-select="true" :options="variantsData.users" :searchable="true" :trackBy="'name'">
            <template v-slot:tag="{ option, handleTagRemove, disabled }">
              <div class="multiselect-tag element" :class="{ 'is-disabled': disabled }">
                <img :src="option.image">
                <div class="user-name">{{ option.name }}</div>
                <span v-if="!disabled" class="multiselect-tag-remove" @mousedown.prevent="handleTagRemove(option, $event)">
                  <span class="multiselect-tag-remove-icon"></span>
                </span>
              </div>
            </template>
            <template v-slot:option="{ option }">
              <div class="option-user">
                <div class="user-image-wrap">
                  <img class="user-image" :src="option.image">
                </div>
                <div class="user-name"> {{ option.name }}</div>
              </div>
            </template>
          </Multiselect>
        </div>
      </div>

      <div class="block">
        <div class="filter-post__is-moderate">
          <IsModerate :data="{
              val: bootData.is_moderate,
            }" @onChange="events.onIsModerate"/>
        </div>
      </div>

      <div class="block">
        <div class="filter-post__buttons">
          <label class="form-label">Статус</label>
          <div class="form-selectgroup">
            <label class="form-selectgroup-item">
              <input @change="events.onStatuses" type="checkbox" v-model="bootData.statuses.published" class="form-selectgroup-input">
              <span class="form-selectgroup-label">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-sun me-1" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                  <circle cx="12" cy="12" r="4"></circle>
                  <path d="M3 12h1m8 -9v1m8 8h1m-9 8v1m-6.4 -15.4l.7 .7m12.1 -.7l-.7 .7m0 11.4l.7 .7m-12.1 -.7l-.7 .7"></path>
                </svg>
                Активно
              </span>
            </label>
            <label class="form-selectgroup-item">
              <input @change="events.onStatuses" type="checkbox" v-model="bootData.statuses.scheduled" class="form-selectgroup-input">
              <span class="form-selectgroup-label">
                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-calendar-event me-1" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                  <rect x="4" y="5" width="16" height="16" rx="2"></rect>
                  <line x1="16" y1="3" x2="16" y2="7"></line>
                  <line x1="8" y1="3" x2="8" y2="7"></line>
                  <line x1="4" y1="11" x2="20" y2="11"></line>
                  <rect x="8" y="15" width="2" height="2"></rect>
                </svg>
                Отложено
              </span>
            </label>
            <label class="form-selectgroup-item">
              <input @change="events.onStatuses" type="checkbox" v-model="bootData.statuses.removed" class="form-selectgroup-input">
              <span class="form-selectgroup-label">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                     class="icon icon-tabler icons-tabler-outline icon-tabler-bulb-off me-1"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path
                    d="M3 12h1m8 -9v1m8 8h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7"/><path
                    d="M11.089 7.083a5 5 0 0 1 5.826 5.84m-1.378 2.611a5.012 5.012 0 0 1 -.537 .466a3.5 3.5 0 0 0 -1 3a2 2 0 1 1 -4 0a3.5 3.5 0 0 0 -1 -3a5 5 0 0 1 -.528 -7.544"/><path
                    d="M9.7 17h4.6"/><path d="M3 3l18 18"/>
                </svg>
                Выключено
              </span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "./css/style.css"
import {defineComponent} from "vue"
import Multiselect from "@/plugins/multiselect"
import Datepicker from "@/plugins/datepicker"
import { useFilter } from './Filter.js'
import IsModerate from "./components/is_moderate/Index"

export default defineComponent({
  name: "NotesFilter",
  components: {
    IsModerate,
    Datepicker,
    Multiselect,
  },
  props: {
    enable: {
      type: Boolean,
      required: true
    },
    params: {
      type: Object,
      required: true
    },
  },
  setup(props, {emit}) {
    const {
      events,
      bootData,
      variantsData,
      isEnable,
      isReadyComponent,
      showOptions,
      isShowOptions,
    } = useFilter(props, {emit})

    return {
      events,
      bootData,
      variantsData,
      isEnable,
      isReadyComponent,
      showOptions,
      isShowOptions,
    }
  }
})
</script>

<style scoped></style>
